import Link from 'next/link';

import { EntityListArticleItem } from '@/shared/api/__generated__/models';
import { Box, Button, Text } from '@/shared/ui';
import { InViewport } from '../InViewport';
import { Article } from './Article';
import { ArticleSkeleton } from './Article/Skeleton';
import styles from './Topic.module.css';

interface TopicProps {
  title: string;
  articles: EntityListArticleItem[];
  highlight?: string;
  onFetchMore?: () => void;
  isFetching?: boolean;
  hasNextPage?: boolean;
  placeholder?: string;
  redirectUrl?: string;
}

export const Topic = ({
  title,
  articles,
  highlight,
  onFetchMore,
  isFetching,
  hasNextPage,
  placeholder,
  redirectUrl,
}: TopicProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>
        {title ? (
          <Box
            display="flex"
            justifyContent="space-between"
            gap={12}
            paddingBottom={26}
            paddingTop={8}
          >
            <Text className={styles.title} color="black" variant="secondary">
              {title}
            </Text>
            {redirectUrl && (
              <Link href={redirectUrl}>
                <Button>Ещё</Button>
              </Link>
            )}
          </Box>
        ) : null}

        <Box
          className={styles.content}
          display="flex"
          flexDirection="column"
          borderRadius={16}
        >
          {!articles.length && !isFetching && (
            <div className={styles.placeholder}>
              <Text fontSize={18} color="black" fontWeight={600}>
                {placeholder ?? 'Нет результатов'}
              </Text>
            </div>
          )}

          {articles.map((article, idx) => (
            <Article
              className={styles.article}
              article={article}
              highlight={highlight}
              key={idx}
            />
          ))}

          {isFetching && (
            <>
              <ArticleSkeleton />
              <ArticleSkeleton />
              <ArticleSkeleton />
            </>
          )}

          {onFetchMore && (
            <InViewport
              onInViewport={onFetchMore}
              isActive={!isFetching && !!hasNextPage}
            />
          )}
        </Box>
      </div>
    </div>
  );
};
